<script>
import { crudMethods } from '@/src/state/helpers'

export default {
  name: 'IkhtisarViewModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    ikhtisarHd: {
      type: Object,
      default: () => ({}),
    },

    proyek: {
      type: Object,
      default: () => ({}),
    },

    details: {
      type: Array,
      default: () => [],
    },

    tagihansDb: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      modalVisible: this.value,
      isSaving: false,
      isDownloading: false,
      localDetails: [],
    }
  },

  watch: {
    value(val) {
      this.modalVisible = val
    },

    modalVisible(val) {
      this.$emit('input', val)
    },

    details: {
      handler(val) {
        this.localDetails = (val || []).map((item) => {
          let cleanDate = ''

          if (item.tgl) {
            cleanDate = item.tgl.includes('T')
              ? item.tgl.split('T')[0]
              : item.tgl
          }

          const initialNominal =
            item.nominal !== undefined && item.nominal !== null
              ? Number(item.nominal)
              : 0

          return {
            ...item,
            tgl: cleanDate,
            nominal: initialNominal,
            nominal_input_format: this.formatRupiahWithoutRp(initialNominal),
          }
        })
      },

      deep: true,
      immediate: true,
    },
  },

  computed: {
    // =========================================================
    // STATUS APPROVED
    // =========================================================
    isApproved() {
      return this.ikhtisarHd && this.ikhtisarHd.status === 'APPROVED'
    },

    // =========================================================
    // TABLE ROWS
    //
    // LOGIKA MATCHING DENGAN REGISTER EVENTS BACKEND
    // =========================================================
    tableRows() {
      const rows = []
      const renderedDetailIds = []

      // =======================================================
      // 1. ITERASI TAGIHAN
      // =======================================================
      if (this.tagihansDb && this.tagihansDb.length > 0) {
        this.tagihansDb.forEach((tagihan) => {
          const matchedDetail = this.localDetails.find((item) => {
            if (!item.tagihan_no || renderedDetailIds.includes(item.id)) {
              return false
            }

            const delimiters = ['&', ',', 'dan', ';']

            let readyString = String(item.tagihan_no)

            delimiters.forEach((del) => {
              readyString = readyString.split(del).join('|')
            })

            const explodedClean = readyString.split('|').map((p) => p.trim())

            return explodedClean.includes(String(tagihan.no))
          })

          const row = {
            isFirstInGroup: true,

            no: '',

            tgl_rekor:
              tagihan.tanggal_bayar || this.ikhtisarHd.tgl_tutup_panjar,

            faktur: tagihan.faktur || '-',

            uraian_bank: this.generateUraianBank(tagihan),

            rc_nominal_bank: tagihan.beban_sph_vendor || 0,

            total_tagihan: tagihan.beban_sph_vendor || 0,

            beban_sph_vendor: tagihan.beban_sph_vendor || 0,

            hasPanjar: !!matchedDetail,

            panjarRef: matchedDetail || null,
          }

          if (row.hasPanjar) {
            renderedDetailIds.push(matchedDetail.id)
          }

          rows.push(row)
        })
      }

      // =======================================================
      // 2. PANJAR YANG BELUM TERKAIT TAGIHAN
      // =======================================================
      const remainingDetails = this.localDetails.filter(
        (item) => !renderedDetailIds.includes(item.id)
      )

      remainingDetails.forEach((remainDetail) => {
        rows.push({
          isFirstInGroup: true,

          no: '',

          tgl_rekor: null,

          faktur: '-',

          uraian_bank: '-',

          rc_nominal_bank: 0,

          total_tagihan: 0,

          beban_sph_vendor: 0,

          hasPanjar: true,

          panjarRef: remainDetail,
        })
      })

      return rows
    },

    // =========================================================
    // TOTAL
    // =========================================================
    totals() {
      let bank = 0
      let tagihan = 0
      let sph = 0
      let panjar = 0

      this.tableRows.forEach((row) => {
        bank += Number(row.rc_nominal_bank || 0)

        tagihan += Number(row.total_tagihan || 0)

        sph += Number(row.beban_sph_vendor || 0)
      })

      this.localDetails.forEach((item) => {
        panjar += Number(item.nominal || 0)
      })

      return {
        bank,
        tagihan,
        sph,
        panjar,
      }
    },
  },

  methods: {
    ...crudMethods,

    // =========================================================
    // GENERATE URAIAN BANK
    // =========================================================
    generateUraianBank(tagihan) {
      const tglMulai = this.proyek.tanggal_mulai
        ? this.formatDateExcel(this.proyek.tanggal_mulai)
        : '-'

      const tglAkhir = this.proyek.tanggal_berakhir
        ? this.formatDateExcel(this.proyek.tanggal_berakhir)
        : '-'

      const nomorDisplay = tagihan.no

      let mekanismeDetail = ''

      const mekanisme = String(
        this.proyek.mekanisme_pembayaran || ''
      ).toUpperCase()

      if (mekanisme === 'TERMIN') {
        mekanismeDetail = 'TERMIN ' + nomorDisplay
      } else if (mekanisme === 'MRC') {
        const tglTutup = this.ikhtisarHd.tgl_tutup_panjar
          ? new Date(this.ikhtisarHd.tgl_tutup_panjar)
          : new Date()

        const bulan = tglTutup.toLocaleString('en-US', {
          month: 'long',
        })

        mekanismeDetail = `Bulan ${bulan} No. ${nomorDisplay}`
      } else {
        mekanismeDetail = `${mekanisme} No. ${nomorDisplay}`
      }

      return `${this.proyek.kode_proyek || ''} ${this.proyek.nama_proyek ||
        ''} - Periode ${tglMulai} s/d ${tglAkhir} - ${mekanismeDetail}`
    },

    // =========================================================
    // FORMAT DATE EXCEL
    // =========================================================
    formatDateExcel(date) {
      if (!date) return '-'

      const d = new Date(date)

      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ]

      return `${String(d.getDate()).padStart(2, '0')}-${
        months[d.getMonth()]
      }-${String(d.getFullYear()).slice(-2)}`
    },

    // =========================================================
    // FORMAT RUPIAH
    // =========================================================
    formatRupiah(val) {
      const numericValue = Number(val) || 0

      const roundedValue = Math.round(numericValue)

      if (roundedValue === 0) {
        return '0'
      }

      return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    // =========================================================
    // FORMAT RUPIAH TANPA RP
    // =========================================================
    formatRupiahWithoutRp(value) {
      const numericValue = Number(value) || 0

      const roundedValue = Math.round(numericValue)

      if (roundedValue === 0) {
        return '0'
      }

      return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    // =========================================================
    // INPUT NOMINAL
    // =========================================================
    handleNominalInput(panjarItem) {
      let cleanValue = String(panjarItem.nominal_input_format).replace(
        /[^0-9]/g,
        ''
      )

      if (cleanValue === '') {
        cleanValue = '0'
      }

      panjarItem.nominal = Number(cleanValue)

      panjarItem.nominal_input_format = cleanValue
    },

    // =========================================================
    // BLUR NOMINAL
    // =========================================================
    handleNominalBlur(panjarItem) {
      panjarItem.nominal_input_format = this.formatRupiahWithoutRp(
        panjarItem.nominal
      )
    },

    // =========================================================
    // FORMAT DATE FULL
    // =========================================================
    formatDateFull(date) {
      if (!date) return '-'

      return new Date(date).toLocaleDateString('id-ID', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      })
    },

    // =========================================================
    // HAPUS ROW PANJAR
    //
    // Hanya menghapus dari localDetails.
    //
    // Backend baru menerima perubahan ketika
    // user menekan "Simpan Perubahan Panjar".
    // =========================================================
    hapusPanjar(panjarItem) {
      if (this.isApproved) return
      if (!panjarItem) return

      const index = this.localDetails.findIndex((item) => {
        if (panjarItem.id !== undefined && panjarItem.id !== null) {
          return Number(item.id) === Number(panjarItem.id)
        }

        return item === panjarItem
      })

      if (index === -1) return

      const uraian = panjarItem.uraian || 'Panjar ini'

      this.$bvModal
        .msgBoxConfirm(
          `Apakah anda yakin ingin menghapus "${uraian}" dari ikhtisar?`,
          {
            title: 'Mohon Konfirmasi',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YA',
            cancelTitle: 'TIDAK',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (!value) return

          // Hapus dari data lokal.
          // Data akan benar-benar dihapus di backend
          // ketika user menekan "Simpan Perubahan Panjar".
          this.localDetails.splice(index, 1)
        })
        .catch(() => {
          // User menutup modal / terjadi cancel.
        })
    },

    // =========================================================
    // SIMPAN PERUBAHAN
    // =========================================================
    simpanPerubahan() {
      if (this.isApproved) {
        return
      }

      this.isSaving = true

      const cleanDetailsToSend = this.localDetails.map((item) => {
        const copy = {
          ...item,
        }

        delete copy.nominal_input_format

        return copy
      })

      this.$emit('save-changes', {
        details: cleanDetailsToSend,

        onSuccess: () => {
          this.isSaving = false
          this.modalVisible = false
        },

        onError: () => {
          this.isSaving = false
        },
      })
    },

    // =========================================================
    // DOWNLOAD EXCEL
    // =========================================================
    downloadExportExcel() {
      this.isDownloading = true

      const proyekId = this.$route.params.id

      const ikhtisarId = this.ikhtisarHd.id

      this.downloadData({
        url: `/web/transaksi/proyek/${proyekId}/panjar-ikhtisar/${ikhtisarId}/export-excel`,
      })
        .then((response) => {
          this.isDownloading = false

          const url = window.URL.createObjectURL(new Blob([response.data]))

          const link = document.createElement('a')

          link.href = url

          const namaFile = `Ikhtisar_Rekonsiliasi_${this.proyek.kode_proyek ||
            'Panjar'}.xlsx`

          link.setAttribute('download', namaFile)

          document.body.appendChild(link)

          link.click()

          document.body.removeChild(link)

          window.URL.revokeObjectURL(url)
        })
        .catch((err) => {
          this.isDownloading = false

          alert('Gagal mengunduh file laporan export excel.')

          console.error(err)
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalVisible"
    centered
    no-close-on-backdrop
    title="Preview & Edit Ikhtisar Penutupan Panjar"
    size="xl"
    header-text-variant="white"
    modal-class="modal-print"
  >
    <div class="excel-preview-container p-2 bg-white text-dark">
      <!-- =====================================================
           TITLE
           ===================================================== -->
      <div class="text-center mb-4">
        <h4 class="font-weight-bold m-0 text-uppercase text-excel-title">
          IKHTISAR PENUTUPAN PANJAR
        </h4>

        <h5 class="font-weight-bold text-excel-subtitle">
          TGL
          {{ formatDateFull(ikhtisarHd.tgl_tutup_panjar) }}
        </h5>

        <div v-if="isApproved" class="mt-2">
          <span class="badge badge-success px-3 py-2 font-size-11">
            <i class="fa fa-check-circle mr-1"></i>

            DOKUMEN INI TELAH DI-APPROVE (READ ONLY)
          </span>
        </div>
      </div>

      <!-- =====================================================
           TABLE
           ===================================================== -->
      <div class="table-responsive border">
        <table class="table table-bordered table-sm m-0 excel-styled-table">
          <thead>
            <tr class="bg-excel-header text-center font-weight-bold">
              <th
                rowspan="2"
                class="align-middle border-dark"
                style="width: 3%"
              >
                No
              </th>

              <th
                colspan="4"
                class="align-middle border-dark"
                style="width: 47%"
              >
                REKENING KORAN BANK
              </th>

              <th
                colspan="2"
                class="align-middle border-dark"
                style="width: 20%"
              >
                TAGIHAN
              </th>

              <th
                colspan="3"
                class="align-middle border-dark"
                style="width: 30%"
              >
                PANJAR
              </th>

              <!-- ACTION -->
              <th
                rowspan="2"
                class="align-middle border-dark"
                style="width: 5%"
              >
                Aksi
              </th>
            </tr>

            <tr class="bg-excel-header text-center font-weight-bold">
              <th class="align-middle border-dark" style="width: 8%">
                TGL
              </th>

              <th class="align-middle border-dark" style="width: 10%">
                FAKTUR
              </th>

              <th class="align-middle border-dark" style="width: 21%">
                URAIAN
              </th>

              <th class="align-middle border-dark" style="width: 8%">
                NOMINAL BANK
              </th>

              <th class="align-middle border-dark" style="width: 10%">
                TAGIHAN
              </th>

              <th class="align-middle border-dark" style="width: 10%">
                HUTANG VENDOR
              </th>

              <th class="align-middle border-dark" style="width: 8%">
                TGL
              </th>

              <th class="align-middle border-dark" style="width: 14%">
                URAIAN
              </th>

              <th class="align-middle border-dark" style="width: 8%">
                NILAI PANJAR
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(row, idx) in tableRows" :key="idx">
              <!-- NO -->
              <td
                class="text-center align-top border-muted font-weight-bold bg-light-cell"
              >
                {{ row.no }}
              </td>

              <!-- =================================================
                   BANK
                   ================================================= -->
              <template v-if="row.tgl_rekor">
                <td class="text-center align-top border-muted">
                  {{ formatDateExcel(row.tgl_rekor) }}
                </td>

                <td class="align-top border-muted text-break font-size-11">
                  {{ row.faktur }}
                </td>

                <td class="align-top border-muted font-size-11 cell-wrap-text">
                  {{ row.uraian_bank }}
                </td>

                <td
                  class="text-right align-top border-muted font-weight-bold text-dark"
                >
                  {{
                    row.rc_nominal_bank > 0
                      ? formatRupiah(row.rc_nominal_bank)
                      : '0'
                  }}
                </td>

                <td
                  class="text-right align-top border-muted font-weight-bold text-dark"
                >
                  {{
                    row.total_tagihan > 0
                      ? formatRupiah(row.total_tagihan)
                      : '0'
                  }}
                </td>

                <td
                  class="text-right align-top border-muted font-weight-bold text-dark"
                >
                  {{
                    row.beban_sph_vendor > 0
                      ? formatRupiah(row.beban_sph_vendor)
                      : '0'
                  }}
                </td>
              </template>

              <!-- BANK EMPTY -->
              <template v-else>
                <td class="text-center align-top border-muted">
                  -
                </td>

                <td class="text-center align-top border-muted">
                  -
                </td>

                <td class="align-top border-muted text-muted font-size-11">
                  -
                </td>

                <td class="text-right align-top border-muted">
                  0
                </td>

                <td class="text-right align-top border-muted">
                  0
                </td>

                <td class="text-right align-top border-muted">
                  0
                </td>
              </template>

              <!-- =================================================
                   PANJAR
                   ================================================= -->
              <template v-if="row.hasPanjar && row.panjarRef">
                <!-- TANGGAL -->
                <td class="align-middle border-dark-side p-1">
                  <input
                    v-model="row.panjarRef.tgl"
                    type="date"
                    class="form-control form-control-sm cell-input font-size-11 text-center"
                    :class="{
                      'bg-disabled-cell': isApproved,
                    }"
                    :disabled="isApproved"
                  />
                </td>

                <!-- URAIAN -->
                <td class="align-middle border-dark-side p-1">
                  <textarea
                    v-model="row.panjarRef.uraian"
                    rows="2"
                    class="form-control form-control-sm cell-input font-size-11"
                    :class="{
                      'bg-disabled-cell': isApproved,
                    }"
                    :disabled="isApproved"
                    placeholder="Uraian panjar"
                  ></textarea>
                </td>

                <!-- NILAI -->
                <td class="align-middle border-dark-side p-1">
                  <input
                    v-model="row.panjarRef.nominal_input_format"
                    type="text"
                    class="form-control form-control-sm cell-input font-size-11 font-weight-bold text-right text-success"
                    :class="{
                      'bg-disabled-cell': isApproved,
                    }"
                    :disabled="isApproved"
                    @input="handleNominalInput(row.panjarRef)"
                    @blur="handleNominalBlur(row.panjarRef)"
                  />
                </td>
              </template>

              <!-- PANJAR EMPTY -->
              <template v-else>
                <td class="text-center align-top border-muted">
                  -
                </td>

                <td class="align-top border-muted text-muted font-size-11">
                  -
                </td>

                <td class="text-right align-top border-muted">
                  0
                </td>
              </template>

              <!-- =================================================
                   HAPUS ROW
                   ================================================= -->
              <td class="text-center align-middle border-dark-side action-cell">
                <button
                  v-if="row.hasPanjar && row.panjarRef && !isApproved"
                  type="button"
                  class="btn btn-sm btn-outline-danger delete-row-btn"
                  title="Hapus panjar dari ikhtisar"
                  @click="hapusPanjar(row.panjarRef)"
                >
                  <i class="uil uil-trash-alt"></i>
                </button>
              </td>
            </tr>

            <!-- =================================================
                 TOTAL
                 ================================================= -->
            <tr class="font-weight-bold bg-excel-total">
              <td colspan="4" class="text-center align-middle border-dark">
                JUMLAH
              </td>

              <td class="text-right align-middle border-dark">
                Rp
                {{ formatRupiah(totals.bank) }}
              </td>

              <td class="text-right align-middle border-dark">
                Rp
                {{ formatRupiah(totals.tagihan) }}
              </td>

              <td class="text-right align-middle border-dark">
                Rp
                {{ formatRupiah(totals.sph) }}
              </td>

              <td colspan="2" class="border-dark bg-excel-total"></td>

              <td class="text-right align-middle border-dark text-success">
                Rp
                {{ formatRupiah(totals.panjar) }}
              </td>

              <!-- TOTAL ACTION -->
              <td class="border-dark bg-excel-total"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- =====================================================
           SIGNATURE
           ===================================================== -->
      <div class="row mt-5 text-center font-size-12 signature-section">
        <div class="col-4">
          <p class="mb-1">
            Mengetahui
          </p>

          <p class="font-weight-bold mb-5">
            Bendahara
          </p>

          <p class="font-weight-bold text-underline mt-4 text-uppercase">
            {{
              ikhtisarHd.bendahara || proyek.bendahara || 'MITA PERMANA SARI'
            }}
          </p>
        </div>

        <div class="col-4">
          <p class="mb-1">
            Mengetahui
          </p>

          <p class="font-weight-bold mb-5">
            Kabag administrasi
          </p>

          <p class="font-weight-bold text-underline mt-4 text-uppercase">
            {{ proyek.kabag_kemitraan || 'R.NANI NURNANINGSIH' }}
          </p>
        </div>

        <div class="col-4">
          <p class="mb-1 text-muted font-italic">
            Surabaya,
            {{ formatDateFull(ikhtisarHd.tgl_tutup_panjar) }}
          </p>

          <p class="font-weight-bold mb-5">
            Pemegang Kas,
          </p>

          <p class="font-weight-bold text-underline mt-4 text-uppercase">
            {{ ikhtisarHd.ketua || proyek.sekretaris || 'FELINA APRILIA A' }}
          </p>
        </div>
      </div>
    </div>

    <!-- =======================================================
         FOOTER
         ======================================================= -->
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between align-items-center">
        <!-- INFO -->
        <span class="text-muted small font-italic">
          <span v-if="!isApproved">
            *Ubah data Tanggal, Uraian, dan Nilai Panjar langsung pada grid
            kuning tabel di atas.
          </span>

          <span v-else class="text-danger font-weight-bold">
            *Dokumen ini dikunci karena sudah berstatus APPROVED.
          </span>
        </span>

        <!-- ACTION -->
        <div>
          <!-- TUTUP -->
          <b-button
            variant="outline-secondary"
            class="mr-2"
            :disabled="isSaving || isDownloading"
            @click="modalVisible = false"
          >
            <i class="uil uil-times mr-1"></i>
            Tutup
          </b-button>

          <!-- EXPORT -->
          <b-button
            variant="info"
            class="mr-2 px-3"
            :disabled="isDownloading || isSaving"
            @click="downloadExportExcel"
          >
            <b-spinner v-if="isDownloading" small class="mr-1"></b-spinner>

            <i v-else class="fa fa-file-excel mr-1"></i>

            {{ isDownloading ? 'Mengunduh...' : 'Export Excel' }}
          </b-button>

          <!-- SIMPAN -->
          <b-button
            v-if="!isApproved"
            variant="success"
            class="px-3"
            :disabled="isSaving || isDownloading"
            @click="simpanPerubahan"
          >
            <b-spinner v-if="isSaving" small class="mr-1"></b-spinner>

            <i v-else class="fa fa-save mr-1"></i>

            {{ isSaving ? 'Menyimpan...' : 'Simpan Perubahan Panjar' }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<style scoped>
/* =========================================================
   TITLE
   ========================================================= */

.text-excel-title {
  font-family: 'Arial', sans-serif;
  font-size: 18px;
}

.text-excel-subtitle {
  font-size: 13px;
}

/* =========================================================
   EXCEL TABLE
   ========================================================= */

.excel-styled-table {
  font-family: 'Arial', sans-serif;
  border: 2px solid #000 !important;
}

.bg-excel-header {
  background-color: #eaeaea;
  color: #000;
  font-size: 11px;
}

.bg-excel-total {
  background-color: #f1f3f5;
  font-size: 11px;
}

.excel-styled-table td,
.excel-styled-table th {
  border: 1px solid #666 !important;
}

.border-muted {
  border: 1px solid #dee2e6 !important;
}

.bg-light-cell {
  background-color: #f8f9fa;
}

/* =========================================================
   FONT
   ========================================================= */

.font-size-11 {
  font-size: 11px;
}

.font-size-12 {
  font-size: 12px;
}

/* =========================================================
   CELL
   ========================================================= */

.cell-wrap-text {
  white-space: normal;
  max-width: 280px;
}

.text-underline {
  text-decoration: underline;
}

/* =========================================================
   INPUT
   ========================================================= */

.cell-input {
  border: 1px solid #bce0fd;
  border-radius: 0;
  padding: 2px 4px;
  height: 28px;
  background-color: #fffde7;
}

.cell-input:focus {
  background-color: #ffffff;
  border-color: #28a745;
  box-shadow: none;
}

textarea.cell-input {
  height: auto;
  resize: vertical;
}

.bg-disabled-cell {
  background-color: #f1f3f5 !important;
  color: #6c757d !important;
  border-color: #ced4da !important;
  cursor: not-allowed;
}

/* =========================================================
   ACTION COLUMN
   ========================================================= */

.action-cell {
  width: 55px;
  min-width: 55px;
  padding: 4px !important;
}

.delete-row-btn {
  width: 30px;
  height: 30px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.delete-row-btn:hover {
  color: #fff;
}

/* =========================================================
   FOOTER
   ========================================================= */

.modal-footer {
  padding: 10px 16px;
}

.modal-footer .btn {
  font-size: 12px;
  font-weight: 600;
}

/* =========================================================
   RESPONSIVE
   ========================================================= */

@media (max-width: 768px) {
  .excel-styled-table {
    min-width: 1100px;
  }
}
</style>
